import { useState } from 'react'

export const useClicked = () => {
  const [clicked, setClicked] = useState<boolean>(false)
  return { clicked, setClicked }
}
